import { addGlobalEventProcessor, getCurrentHub } from '@sentry/core';
import { Event, Integration } from '@sentry/types';
import { getGlobalObject } from '@sentry/utils';
import { getClient } from '../client';

const global = getGlobalObject<Window>();

const queryString = (name: string): string => {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  const r = global.location.search.substr(1).match(reg);
  if (r != null) {
    if (r != null) {
      return decodeURIComponent(r[2]);
    }
  }
  return '';
}

const getCookie = (name: string): string => {
  let arr; const reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
  if(arr = document.cookie.match(reg))
    return unescape(arr[2]);
  return '';
}



/** HttpContext integration collects information about HTTP request headers */
export class Custom implements Integration {
  /**
   * @inheritDoc
   */
  public static id: string = 'Custom';

  /**
   * @inheritDoc
   */
  public name: string = Custom.id;

  /**
   * @inheritDoc
   */
  public setupOnce(): void {
    addGlobalEventProcessor((event: Event) => {
      if (getCurrentHub().getIntegration(Custom)) {
        // if none of the information we want exists, don't bother
        if (!global.navigator && !global.location && !global.document) {
          return event;
        }

        const cid = queryString('cid') || queryString('user_cid') || queryString('userCid') || getCookie('cid') || (localStorage && localStorage.getItem('cid')) || (sessionStorage && sessionStorage.getItem('cid')) || queryString('encrypted_cid')  || queryString('driver_id') || '';
        const client = getClient();
        const tags = {
          ...event.tags,
          user_cid: cid,
          client
        };

        return {
          ...event,
          tags
        };
      }
      return event;
    });
  }
}
